import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ModalParagraph, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledConfirmationModalTitle = styled(ModalTitle)(
    ({theme: {typography}}) => css`
        ${typography.textXl};
    `
)

export const StyledConfirmationModalLighterParagraph = styled(ModalParagraph)(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[500]};
    `
)

export const StyledConfirmationModalAccordionButton = styled(Button)(
    ({theme: {palette}}) => css`
        justify-content: space-between;
        font-weight: 400;
        color: ${palette.neutral[950]};

        & b {
            font-weight: 500;
        }
    `
)

export const StyledConfirmationModalAccordionContainer = styled(Flexbox)`
    flex-wrap: wrap;
`
